import { bursariesApi } from "../../api/hliLists";
import GrantedStudentsPage from "../granted/GrantedStudentsPage";

// Every institution's students granted a bursary
export default function GrantedStudents() {
  return <GrantedStudentsPage list={bursariesApi.granted} scope="all" subtitle="Students granted a bursary, with the BRD products their loan covers" />;
}
